import React from "react";
import { useParams } from "react-router-dom";
import useScoFormsEnabled from "../../hooks/useScoFormsEnabled";
import EditUserPage from "./EditUserPage";
import LegacyEditUserPage from "./LegacyEditUserPage";
import LoadingTablePage from "../LoadingTablePage";

/**
 * Picks the edit page by the agreement's SCO flag (PBI #385): the SCO page when it is on,
 * the production role + billing-group page otherwise. Decided here rather than inside
 * EditUserPage, which starts its SCO fetches on mount.
 */
const EditUserRoute = () => {
  const { agreementPublicId } = useParams();
  const { enabled, loaded } = useScoFormsEnabled(agreementPublicId);

  if (!loaded) return <LoadingTablePage title={"Users"} loading={true} />;
  return enabled ? <EditUserPage /> : <LegacyEditUserPage />;
};

export default EditUserRoute;
